import React from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const isTokenExpired = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (e) {
    return true;
  }
};

const ProtectedRoute = ({ children }) => {
  if (isTokenExpired()) {
    toast.error("Your session has expired, please login again");
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
